import { render } from "./Other_Fees.vue?vue&type=template&id=5026be18"
import script from "./Other_Fees.vue?vue&type=script&lang=js"
export * from "./Other_Fees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__